import React, { useEffect, useRef, useState } from 'react';
import { useRequest } from 'ahooks';
import http from '@/utils/http';
import {
  RequrstBack,
  queryInitStatClientConfig,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/hooks';


// company detail Companies 页获取子母公司列表
export const useSubsidiaryCompanies = <T extends unknown>(params: T) => {
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/subsidiaryCompanies',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'subsidiaryCompanies',
    manual: false,
    loadingDelay: 0,
  });
  return {
    ...data,
  };
};

const LazyLoadImage = ({ src, alt }: { src: string; alt: string }) => {
  const [imageSrc, setImageSrc] = useState<string>('');
  const imgRef = useRef(null);

  useEffect(() => {
    let observer: any;
    if (imgRef.current) {
      observer = new IntersectionObserver(
        ([entry]) => {
          // 当图片进入可视区域时，设置图片地址进行加载
          if (entry.isIntersecting) {
            setImageSrc(src);
            observer.unobserve(imgRef.current);
          }
        },
        {
          rootMargin: '0px 0px 200px 0px', // 可视区域的边距设置为200px
        },
      );
      observer.observe(imgRef.current);
    }
    return () => {
      if (observer && observer.unobserve) {
        observer.unobserve(imgRef.current);
      }
    };
  }, [src]);

  return <img ref={imgRef} src={imageSrc} alt={alt} />;
};

export default LazyLoadImage;
